export type DBObject = { _id: string }

export const isDBObject = (x: any): x is DBObject =>
  !!x && typeof x === 'object' && typeof x._id === 'string'
